export default __webpack_public_path__ + "static/media/playstore.49fcdcc5.svg";